import api from '../api'

export const getCoupons = (params) =>
  api.get('/operation/coupons/', { params })

export const createCoupon = (data) =>
  api.post('/operation/coupons/', data)

export const updateCoupon = (id, data) =>
  api.patch(`/operation/coupons/${id}/`, data)

export const bulkUploadCoupons = (data) =>
  api.post("/operation/coupons/bulk_upload/", data)

export const searchUsers = (query) =>
  api.get(`/operation/users-search/`, { params: { query } })